module.exports = __webpack_public_path__ + "img/2.0a2f9528.jpg";